export {
  getLocalStorageItemOnce,
  getLocalStorage,
  setLocalStorage,
  checkLocalStorage
}

function getLocalStorageItemOnce (name) {
  let value = localStorage.getItem(name)
  localStorage.removeItem(name)
  return value
}

function getLocalStorage (name) {
  return localStorage.getItem(name)
}

function setLocalStorage (name, value) {
  localStorage.setItem(name, value)
}

function checkLocalStorage (name) {
  return localStorage.getItem(name) !== null
}



// WEBPACK FOOTER //
// ./src/utils/api.js